import { Box, styled } from '@mui/material';

export const List = styled(Box)(({ theme }) => ({
  display  : 'flex',
  gap      : '10px',
  flexWrap : 'wrap',
}));
